module.exports = __webpack_public_path__ + "static/media/kishoriMv3.f4468fed.png";